import Vue from 'vue'
import { getOnboardingSteps, getOnboardingProgress, markStepComplete } from '@/hooks/useOnboarding'

export default {
  /**
   * Buscar steps e progress em paralelo
   */
  async fetchOnboardingData({ commit, dispatch }) {
    commit('SET_LOADING', true)
    try {
      const [steps, progress] = await Promise.all([getOnboardingSteps(), getOnboardingProgress()])

      commit('SET_STEPS', steps)
      commit('SET_PROGRESS', progress)

      // Verificar se completou tudo
      dispatch('checkIfComplete')
    } catch (error) {
      console.error('Erro ao buscar dados de onboarding:', error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /**
   * Marcar uma etapa como completa
   * Nota: O hook markStepComplete ja atualiza o store automaticamente,
   * entao esta action apenas delega para o hook
   */
  async markStepComplete(_, stepKey) {
    try {
      return await markStepComplete(stepKey)
    } catch (error) {
      console.error('Erro ao marcar etapa como completa:', error)
      throw error
    }
  },

  /**
   * Toggle do estado expandido da sidebar
   */
  toggleExpanded({ commit, state }) {
    commit('SET_EXPANDED', !state.isExpanded)
  },

  /**
   * Verificar se todas as etapas foram completadas
   */
  checkIfComplete({ commit, state }) {
    const totalSteps = state.steps.length
    const completedSteps = state.progress.length

    const hasCompletedAll = totalSteps > 0 && completedSteps >= totalSteps

    // Se mudou de false para true, disparar evento de celebracao
    if (hasCompletedAll && !state.hasCompletedAll) {
      Vue.bus.$emit('onboarding:completed')
    }

    commit('SET_HAS_COMPLETED_ALL', hasCompletedAll)
  }
}
